(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fervent-maker-pricing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFerventPricing = (root) => {
      if (!root || root.dataset.fmReady === 'true') return;
      root.dataset.fmReady = 'true';
      const buttons = root.querySelectorAll('[data-audience]');
      const partnerNote = root.querySelector('[data-partner-note]');
      const setAudience = (audience) => {
        root.querySelectorAll('[data-standard][data-nonprofit]').forEach((el) => {
          el.textContent = el.dataset[audience];
        });
        buttons.forEach((button) => {
          const active = button.dataset.audience === audience;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (partnerNote) partnerNote.hidden = audience !== 'nonprofit';
      };
      buttons.forEach((button) => button.addEventListener('click', () => setAudience(button.dataset.audience)));
      setAudience('standard');
    };
    document.querySelectorAll('[data-fm-pricing]').forEach(initFerventPricing);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches && event.target.matches('[data-fm-pricing]')
        ? event.target
        : event.target.querySelector('[data-fm-pricing]');
      initFerventPricing(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
